import { Image, Info } from 'components';

export default function PopulationSizeInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Many people standing next to each other" path="population-size.png" title="Population Size" />
        <h5 className="mb-0">Population Size</h5>
        <p>
            <span className="text-error">Mandatory</span>
            <br/>
            <br/>
            This is the total number of individuals in the group that you are <span className="text-decoration-underline">trying to learn about</span>. Your <span className="fst-italic">Sample Size</span> is a smaller group that you are using to represent the larger <span className="fst-italic">Population</span>.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If you want to learn about everyone in Belgium, the <span className="fst-italic">Population</span> is 11.46 million. But it would take too long to get information from all of them. So you pick a smaller <span className="fst-italic">Sample Size</span> within that 11.46 million to test.
            <br/>
            <br/>
            The <span className="fst-italic">Population</span> does not need to be exact, especially if it&apos;s a big number such as more than one million. But if your population size is small, such as 5,000, it should be as accurate as possible.
        </p>
    </Info>;

}